import _ from "lodash";
import axios from "../../../services/api/axios-default";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import httpManager from "../../../services/managers/http";
import * as actions from "./actions";
import { MSG_INIT_APP } from "../../../services/managers/string-literals";

export const onAppLoad = (payload) => (dispatch, getState) => {
  pagePreloaderManager.show(MSG_INIT_APP);

  // Fetch initial app data, like Products
  axios
    .get(httpManager.getAppDataEnpoint() + "?" + httpManager.constructAppDataHttpQueryString())
    .then(function(response) {
      if (
        response.data &&
        response.data.response &&
        _.isArray(response.data.response) &&
        response.data.response.length &&
        _.isObject(response.data.response[0]) &&
        _.isObject(response.data.response[0]["App"]) &&
        _.isArray(response.data.response[0]["App"]["Products"]) &&
        response.data.response[0]["App"]["Products"].length
      ) {
        dispatch(((response) => ({ type: actions.ON_APP_LOAD, payload: { ...payload, response } }))(response.data.response[0]));
      } else {
        dispatch(((error) => ({ type: actions.ON_APP_LOAD, payload: { ...payload, error } }))("Could not fetch products"));
      }
    })
    .catch(function(error) {
      console.error("Catch Error", JSON.stringify(error));
      error = httpManager.transfigureAPIErrorMessages(error);
      dispatch(((error) => ({ type: actions.ON_APP_LOAD, payload: { ...payload, error } }))(error));
    });
};



// WEBPACK FOOTER //
// ./src/store/analytics/analytics/action-creators.js